import abi from "./WalletAbi.json";
import Web3Modals from "web3modal";
import Web3 from "web3";
import swal from "sweetalert";
import WalletConnectProviders from "@walletconnect/web3-provider";
import * as crypto from "crypto-browserify";
import GoldBuxAbi from "./GoldBuxAbi.json"
import {GetMethod} from '../NetworkCalls/Get'
    let web3Modal;
    var userAddress = "";
    var provider = "";
    var infuraId = "c108047574834fb69f16001aee94a25b";
    var chainId = 1;
  
    var contract = "";
var GoldBuxContract = "0x0C81dC8473a321C7919cEffbbF75d212e9096cF3"

export const onConnect=async ()=> {
    return new Promise(async(resolve,reject)=>
    {
        const providerOptions = {
            walletconnect: {
              package: WalletConnectProviders,
              options: {
                infuraId: infuraId,
                chainId: chainId,
              },
            },
          };
          web3Modal = new Web3Modals({
            cacheProvider: false,
            providerOptions,
          });
          if (web3Modal.cachedProvider) {
            web3Modal.clearCachedProvider();
          }
          try {
            provider = await web3Modal.connect();
          } catch (e) {
           reject("Could not get a wallet connection");
            return;
          }
          provider.on("accountsChanged", (accounts) => {
            init(provider).then(res=>
                {
                    resolve(res)
                }).catch(err=>
                    {
                        reject(err)
                    })
          });
          provider.on("chainChanged", (chainId) => {
            init(provider).then(res=>
                {
                    resolve(res)
                }).catch(err=>
                    {
                        reject(err)
                    })
          });
          provider.on("disconnect", (error) => {
           
           
          });
          init(provider).then(res=>
            {
                resolve(res)
            }).catch(err=>
                {
                    reject(err)
                })
    })
  
  }



  async function init(provider) {
    return new Promise(async(resolve,reject)=>
    {
        const web3 = new Web3(provider);
        contract = new web3.eth.Contract(GoldBuxAbi, GoldBuxContract);
       
        web3.eth.getAccounts(async function (err, accounts) {
          if (err != null) {
            reject({err:err})
          } else if (accounts.length === 0) {
           
            reject({err:"Your Wallet is Locked. Please Unlock It To Use DAPP"})
          } else if (web3.currentProvider.chainId != chainId) {
           
            reject({err: chainId == 1
                ? "Make Sure You Are Using The Ethereum Network"
                : "Make Sure You Are Using The Goerli Test Network"})
          } else {
            
            const onBal = parseInt(
              await contract.methods.balanceOf(accounts[0]).call()
            );
            console.log(onBal)
            var sig = "";
            userAddress = accounts[0];
           
            let nonce = Math.random().toString(16).substring(2, 8);
            let message = 
`Welcome!

Sign this message to login to BuxSwap. Nonce (not more than once) is ${nonce}.
Find out more at https://buxswap.io/

This will not trigger a blockchain transaction or incure any fees.`
            
            web3.eth.personal
              .sign(message, accounts[0], nonce)
              .then((signature) => {
                sig = `${signature},${nonce},${accounts[0]}`;
                console.log(sig)
                GetMethod('balances',sig).then(res=>
                  {
                   
                    resolve({walletAddress:accounts[0],auth:sig,GDBX:onBal,EGBX:res[1].balance,Provider:provider})
                  })
               
              });
          }
        });
    })
  
  }